module.exports = __webpack_public_path__ + "img/leftclock.1ce99035.png";